import {AxiosRequestConfig} from "axios";
import DceAjaxRedirectAction from "../../../dce-ajax/lib/ajax/actions/DceAjaxRedirectAction";
import DceWebSocketIncomingMessage from "./DceWebSocketIncomingMessage";
import DceWebSocketSubscribeHandle from "./DceWebSocketSubscribeHandle";

interface IncomingMessageCallback {
    (msg: DceWebSocketIncomingMessage): void
}

interface SubMessage {
    id: number;
    channel: string;
    callback: IncomingMessageCallback
}

export default class DceWebSocketConnection {

    private static instance: DceWebSocketConnection;

    static getInstance(): DceWebSocketConnection {
        if (!DceWebSocketConnection.instance) {
            DceWebSocketConnection.instance = new DceWebSocketConnection();
        }
        return DceWebSocketConnection.instance;
    }

    static openConnection(): DceWebSocketConnection {
        return DceWebSocketConnection.getInstance();
    }

    private openConnectionCount = 0;
    private connectionUrl: string;
    private ws: WebSocket;
    private htmlElementIndicator: HTMLElement;

    private subsIdsCounter = 0;

    private waitingForConnection: SubMessage[] = [];
    private subscribed: SubMessage[] = [];

    private uuid: string;

    constructor() {
        this.connectionUrl = window.location.origin.replace('http', 'ws') + "/ws";
        this.htmlElementIndicator = document.getElementById('dce-websocket-indicator');

        this.uuid = "UUID-" + (Math.random() * 10000);

        this.openConnection();
    }

    public subscribe(channel: string, callback: IncomingMessageCallback): DceWebSocketSubscribeHandle {
        this.subsIdsCounter++;
        let sub: SubMessage = {
            id: this.subsIdsCounter,
            channel: channel,
            callback: callback
        };
        if (null == this.ws) {
            this.waitingForConnection.push(sub);
        } else {
            this.sendSubMessage(sub.channel)
            this.subscribed.push(sub);
        }

        return new DceWebSocketSubscribeHandle(sub.id);
    }

    public unsubscribe(handle: DceWebSocketSubscribeHandle){
        let removeIndex = -1;

        for(var i=0; i<this.subscribed.length; i++){
            if(this.subscribed[i].id == handle.id){
                removeIndex = i;
                break;
            }
        }

        if(removeIndex > -1) {
            var channel = this.subscribed[removeIndex].channel;
            this.sendUnsubMessage(channel);
            this.subscribed.splice(removeIndex, 1);
        }
    }

    private setCurrentConnection(ws: WebSocket) {
        this.ws = ws;
        this.ws.onmessage = (e) => {
            this.onMessage(e);
        };

        while (this.waitingForConnection.length > 0) {
            let awaiting = this.waitingForConnection.pop();
            this.sendSubMessage(awaiting.channel);
            this.subscribed.push(awaiting);
        }

    }

    private onMessage(e:MessageEvent): any {

        let c = e.data;
        console.log("WS<-", c);
        var msg = JSON.parse(e.data) as DceWebSocketIncomingMessage;

        console.log("INCOMING MESSAGE: ", msg);

        for (var i = 0; i < this.subscribed.length; i++) {
            if (this.subscribed[i].channel == msg.channel) {
                this.subscribed[i].callback(msg);
            }
        }
    }

    private sendSubMessage(channel:string){
        console.log("SUB: ", channel);
        this.ws.send(JSON.stringify({
            "sub": channel
        }));
    }

    private sendUnsubMessage(channel:string){
        console.log("UNSUB: ", channel);
        this.ws.send(JSON.stringify({
            "unsub": channel
        }));
    }

    private openConnection() {

        console.log("OPEN CONNECTION: " + this.uuid + this.openConnectionCount);

        if (this.openConnectionCount > 10) {
            console.error("Cannot open WebSocket Connection - try limit");
        }
        this.openConnectionCount++;

        let ws = new WebSocket(this.connectionUrl);

        ws.onopen = (e: Event) => {
            this.setIndicatorState(true);
            this.setCurrentConnection(ws);

            ws.onclose = (e: Event) => {

                console.log("CLOSE CONNECTION " + this.uuid)

                this.ws = null;
                this.setIndicatorState(false);
                this.openConnectionCount = 0;
                this.openConnection();

                //resubscribe
                this.waitingForConnection = this.subscribed;
                this.subscribed = [];

            };
        };

    }

    private setIndicatorState(connected: boolean) {
        if (null != this.htmlElementIndicator) {

            if (connected) {
                this.htmlElementIndicator.classList.remove('disconnected');
                this.htmlElementIndicator.classList.add('connected');
            } else {
                this.htmlElementIndicator.classList.add('disconnected');
                this.htmlElementIndicator.classList.remove('connected');
            }

        }
    }
}